export const formatPhone = (phone?: string): string => {
    if (!phone) return '';
    const digits = phone.replace(/\D/g, '');
    if (digits.length === 10) {
        return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    return phone;
};

export const formatCurrency = (value: number | string | undefined): string => {
    if (value === undefined || value === null || value === '') return '$0.00';
    const n = typeof value === 'number' ? value : parseFloat(value);
    if (Number.isNaN(n)) return '$0.00';
    return n.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
};

export const truncate = (s: string, max = 40): string =>
    s.length <= max ? s : `${s.slice(0, max - 1)}…`;

export const timePassed = (timestamp?: number): string => {
    if (!timestamp) return '';
    const diff = Math.floor((Date.now() - timestamp) / 1000);
    const minute = 60;
    const hour = minute * 60;
    const day = hour * 24;
    const month = day * 30;
    const year = day * 365;

    if (diff < minute) return `${diff} seconds ago`;
    if (diff < hour) return `${Math.floor(diff / minute)} minutes ago`;
    if (diff < day) return `${Math.floor(diff / hour)} hours ago`;
    if (diff < month) return `${Math.floor(diff / day)} days ago`;
    if (diff < year) return `${Math.floor(diff / month)} months ago`;
    return `${Math.floor(diff / year)} years ago`;
};
